import React, { memo } from 'react'
import Page from 'components/layout/Page'
import Section1 from './Section1'
import Section2 from './Section2'

function ContactUs() {
  return (
    <Page>
      <Section1 />
      <Section2 />
    </Page>
  )
}

export default memo(ContactUs)
